<h2 mat-dialog-title>
  {{ isEditMode ? 'Modifier l\'unité organisationnelle' : 'Nouvelle unité organisationnelle' }}
</h2>

<!-- Erreur backend -->
<div *ngIf="backendError" class="backend-error-banner">
  <mat-icon>error_outline</mat-icon>
  <span>{{ backendError }}</span>
</div>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="form">

    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Code</mat-label>
      <input matInput formControlName="code" placeholder="Ex: ACT-GE" maxlength="50">
      <mat-hint align="end">{{ form.get('code')?.value?.length || 0 }}/50</mat-hint>
      <mat-error *ngIf="form.get('code')?.hasError('required')">Champ obligatoire</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Libellé</mat-label>
      <input matInput formControlName="libelle" placeholder="Ex: ACT Grand Est" maxlength="150">
      <mat-hint align="end">{{ form.get('libelle')?.value?.length || 0 }}/150</mat-hint>
      <mat-error *ngIf="form.get('libelle')?.hasError('required')">Champ obligatoire</mat-error>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Annuler</button>
  <button mat-raised-button color="primary"
          type="button"
          (click)="onSubmit()"
          [disabled]="form.invalid || isSubmitting">
    <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
    {{ isEditMode ? 'Modifier' : 'Créer' }}
  </button>
</mat-dialog-actions>